export const DEFAULT_GLOB_PATTERNS = ["**/*.{js,css,html}"];
